let lib; // 动画类
class gameAni {
    constructor(opt) {
        lib = opt.lib; // 动画类
        //ani对象容器存储
        this.aniObj = {
            // 主界面，我的龙
            mainDragonWrap: exportRoot.dragon_ani_wrap.myDragonAni,
            // 主界面，地台
            mainGround: exportRoot.dragon_ani_wrap.groundAni,
            // 左侧龙（我方）
            player1: exportRoot.dragon_ani_wrap.bbbAni,
            // 右侧龙（敌方）
            player2: exportRoot.dragon_ani_wrap.aaaAni,
            // pk动效
            pkEffect: exportRoot.dragon_ani_wrap.effectWrap,
            // winner
            tWinner: new lib.textWinner(),
            // loser
            tLoser: new lib.textLoser(),
            // p1名牌
            p1NameBox: exportRoot.dragon_ani_wrap.pkNameWrap.p1_name_ani,
            // p2名牌
            p2NameBox: exportRoot.dragon_ani_wrap.pkNameWrap.p2_name_ani,
            // iconPk
            iconPk: exportRoot.dragon_ani_wrap.pkNameWrap.iconPk,
            // 弹幕
            dmWrap: exportRoot.dmWrap,
            // 昵称栏
            nameBox: exportRoot.dragon_ani_wrap.nameBoxAni,
            // an弹窗
            popup: exportRoot.popupAni,
            // winner弹窗
            popWinner: exportRoot.popupAni.winnerAni,
            // download弹窗
            popDownload: exportRoot.popupAni.downloadPopAni
        };

        this._lang = 'en'; // 语言，zh,en,ru
        this.isLogin = false; // 是否登录（有龙）
        // 初始化部分元件位置
        this.resetAniObjPosition();
        // 龙id和龙昵称匹配关系
        this.dragonNameObj = {
            // d0: '酒龙',
            // d1: '冲浪龙',
            // d2: '喷火龙',
            // d3: '疫苗龙1',
            // d4: '疫苗龙2',
            // d5: '带珍珠耳环的龙',
            // d6: '戴口罩龙1',
            // d7: '戴口罩龙2',
            // d8: '肥宅龙',
            // d9: '海盗龙',
            // d10: '喝可乐龙',
            // d11: '篮球龙',
            // d12: '乐器龙',
            // d13: '龙二',
            // d14: '龙三',
            // d15: '龙四',
            // d16: '龙五',
            // d17: '龙一',
            // d18: '沙滩度假龙',
            // d19: '玩游戏龙'
        };
        // npc
        this.npcDragonId = 'd2';
        this.npc = {
            id: this.npcDragonId, // 喷火龙
            name: 'NPC',
            winner: false // 默认npc输
        };
        // 用户
        this.myDragon; // 我的龙
        this.myDragonId = opt.dragonId ? opt.dragonId : ''; // 我的龙ID
        this.myName = opt.name ? opt.name : '';
        this.myDragonState = 0; //0:首次登录选龙（大）  1：已有龙（小）  2：登录后无PK记录+战力页状态（大+偏下）

        // 随机生成龙
        this.randomDragonIndex = 0; // 随机龙索引
        this.randomDragonArr = []; // 随机龙初始排序
        this.canChangeDragon = true; // 是否可以切换

        // pk文案库
        this.pkTextList = opt.pkText ? opt.pkText : [];
        this.pkWordsData = null; // 对战记录
        this._basePkWords = {
            zh: {
                pkstart: '开始战斗',
                pkend: '结束战斗'
            },
            en: {
                pkstart: 'Start battle',
                pkend: 'End battle'
            },
            ru: {
                pkstart: 'Начать битву',
                pkend: 'Закончить битву'
            }
        };

        // pk定时器相关
        this._canPk = true; // 是否可以开始pk
        this.pkTimer; // pk定时器
        this.pkRound = 4; // pk轮数：4轮
        this.pkStep = 3; // 每轮步数：3步
        this.roundTime = 1500; //单轮时长 ，单位：ms
        this.pkEffect = ''; // pk动效
        this._pkCount = 0; //pk次数（通过这个判断前往战力页时是否需要getUserInfo，获取后会清0）
        this._reversePlayer = false; // 是否颠倒pk双方龙名

        // 当前位置
        this.curView = '';
        // 弹窗
        this.winnerpopTimer = null; // winner弹窗定时器
        this.curWinner = {}; // 当前胜利玩家

        // 初始化舞台
        this._init();
    }

    // 初始化舞台
    _init() {
        let _this = this;
        // 登录前

        // 随机设置一条龙
        // _this.changeDragon();
        // 设置固定一条龙
        // _this._createMyDragon(this.npcDragonId);

        // 登录后
        // this._myDragonStatus(false, 0);
    }

    // 切换弹幕语言
    changeDmLang(lang) {
        this.aniObj.dmWrap.dm_ani_zh.visible = false;
        this.aniObj.dmWrap.dm_ani_en.visible = false;
        this.aniObj.dmWrap.dm_ani_ru.visible = false;

        if (
            (this.curView == 'start' && lang == 'zh') ||
            lang == 'en' ||
            lang == 'ru'
        ) {
            this.aniObj.dmWrap['dm_ani_' + lang].visible = true;
        }
    }

    /**
     * todo list
     * 1. 下载弹窗
     * 2. winner弹窗
     * 3.
     */

    // 前往x页
    go(page, cb) {
        let _this = this;
        // start 登录前（弹幕）
        // create 登录后-home（初始龙+输入昵称界面）
        // home 登录后-home（slogan）
        // record1 登录后-前置页（无PK记录）
        // record2 登录后-PK结果页（有PK记录）
        // pk PK页
        // share 分享页
        // user 战力页
        // empty 空白页（只有背景，其他啥都没）

        if (page == this.curView) return; // 如果界面没有变化，直接跳过

        // 还有弹幕，则清掉弹幕
        if (page != 'start' && this.aniObj.dmWrap.children.length >= 0) {
            this.aniObj.dmWrap.stop();
            this.aniObj.dmWrap.removeAllChildren();
        }
        switch (page) {
            case 'start': // 登录前（弹幕）
                // 播放弹幕
                // 默认龙
                // 设置固定一条龙
                this._createMyDragon(this.npcDragonId);
                this.setMyDragonState(0); // 设置我的龙显示状态 0 1 2
                // 主页龙出场
                _this._myDragonStatus(true, 500, () => {});
                // 播放弹幕
                setTimeout(() => {
                    this.aniObj.dmWrap.visible = true;
                    this.aniObj.dmWrap.play();
                }, 10);
                break;
            case 'create': // 登录后-home（初始龙+输入昵称界面）
                // 默认龙
                // 属性面板
                // 昵称输入栏（废弃）
                // 设置固定一条龙
                this._createMyDragon(this.npcDragonId);
                this.setMyDragonState(0); // 设置我的龙显示状态 0 1 2
                this.goHome();
                break;
            case 'home': // 登录后-home（带slogan）
                // 默认龙
                // 属性面板
                // 昵称
                // slogan
                // PK中，暂停PK定时器
                this.setMyDragonState(1); // 设置我的龙显示状态 0 1 2
                this.goHome();
                break;
            case 'record1': // 登录后-前置页（无PK记录）
                // 昵称
                // slogan
                // 我的龙
                // 无对战记录提示
                this.setMyDragonState(2); // 设置我的龙显示状态 0 1 2
                this._nameBoxShowStatus(false);
                this.goHome();
                break;
            case 'record2': // 登录后-PK结果页（有PK记录）
                // pk结果
                // pk记录
                this._nameBoxShowStatus(false);
                break;
            case 'share': // 分享页
                // pk昵称
                // 两条龙（位置在中间）
                this._playerYStatus(true);
                break;
            case 'user': // 战力页
                // 我的龙
                this._nameBoxShowStatus(false, 0);
                this.setMyDragonState(2); // 设置我的龙显示状态 0 1 2
                this._myDragonStatus(true, 500);
                this.goHome(false);
                break;
            case 'empty': // 空白页（只有背景，其他啥都没）
                // 只保留背景
                this._myDragonStatus(false, 0);
                this._nameBoxShowStatus(false, 0);
                if (!this.canPk) {
                    this.canPk = true;
                    // 停掉定时器
                    clearInterval(this.pkTimer);
                }
                // PK中，中断PK，清空重置pk双方
                this._resetPkAni();
                this.changeDmLang();
                break;
            default:
                // home
                break;
        }

        // 回调
        cb && cb();
        // 更新当前位置
        this.curView = page;
    }

    // 显示弹窗
    showPop(type) {
        // winner弹窗
        // 下载弹窗
        let _this = this;
        _this.aniObj.popup.visible = true; // 弹窗显示

        if (type == 'winner') {
            // winner弹窗
            _this.aniObj.popWinner.visible = true;
        } else if (type == 'download') {
            // 下载弹窗
            _this.aniObj.popDownload.visible = true;
        }
    }

    // 隐藏弹窗
    hidePop(type) {
        let _this = this;
        this.aniObj.popup.visible = false; // 弹窗隐藏

        if (type == 'winner') {
            // winner弹窗
            _this.aniObj.popWinner.visible = false;
            // 清空winner龙
            _this.aniObj.popWinner.winnerDragonWrap.removeAllChildren(); // 清掉原来的winner
            // 清空winner name
            _this.aniObj.popWinner.winnerNameBox.winnerName.text = '';
            // 停止winner光效转圈圈
            _this.aniObj.popWinner.lightAni.stop();
            // 清除定时器
            clearTimeout(_this.winnerpopTimer);
        } else if (type == 'download') {
            // 下载弹窗
            _this.aniObj.popDownload.visible = false;
            // 清空下载弹窗的龙
            _this.aniObj.popDownload.downloadPopDragonWrap.removeAllChildren(); // 清掉原来的龙
        }
    }

    // winner弹窗
    popWinner(cb) {
        let _this = this;
        let _winner = _this.curWinner;
        let _winnerDragon = _this._createDragon(_winner.id);
        _this.showPop('winner');
        _this.aniObj.popWinner.lightAni.play();
        _this.aniObj.popWinner.winnerDragonWrap.addChild(_winnerDragon); // 插入新winner
        _this.aniObj.popWinner.winnerNameBox.winnerName.text = _this.translateNameText(
            _winner.name,
            _this.getDragonNameById(_winner.id)
        );

        // 动效
        createjs.Tween.get(_this.aniObj.popWinner)
            .to(
                {
                    alpha: 0,
                    scaleX: 0.5,
                    scaleY: 0.5
                },
                0
            )
            .to(
                {
                    alpha: 1,
                    scaleX: 1,
                    scaleY: 1
                },
                500,
                createjs.Ease.quadIn
            )
            .call(() => {
                // 启动winnerpop定时器
                _this.winnerpopTimer = setTimeout(() => {
                    // 回调
                    cb && cb();
                }, 3000);
            });
    }
    // download弹窗
    popDownload(cb) {
        let _this = this;
        let _myDragon = _this._createDragon(_this.myDragonId);
        _this.showPop('download');
        _this.aniObj.popDownload.downloadPopDragonWrap.addChild(_myDragon); // 插入新winner

        // 回调
        cb && cb();
    }

    // 设置我的龙
    setUser(data) {
        let _this = this;
        // 有龙id
        if (data.dragonId) {
            _this.myDragonId = data.dragonId; // 我的龙ID
        }
        // 有用户名
        if (data.name) {
            _this.myName = data.name; // 用户昵称
            let _text = _this.translateNameText(
                _this.myName,
                _this.getDragonNameById(_this.myDragonId)
            );
            _this.updateNameBox(_text);
        }
        // 创建我的龙，添加到舞台
        _this._createMyDragon(_this.myDragonId);
    }

    // 设置龙id和名称
    setDragonData(arr) {
        let _this = this;
        let _data = {};
        for (let i = 0; i < arr.length; i++) {
            let _dragon = arr[i];
            _data[_dragon.ename] = {
                ename: _dragon.ename,
                name: _dragon.name,
                id: _dragon.id
            };
        }

        _this.dragonNameObj = _data;
    }

    // 添加pk文案
    updatePkWords(arr) {
        this.pkTextList = [];
        this.pkTextList = this.pkTextList.concat(arr);
    }

    // 根据id生成龙
    _createDragon(dragonId) {
        return new lib[dragonId]();
    }

    // 生成我的龙
    _createMyDragon(dragonId) {
        let _this = this;
        _this.aniObj.mainDragonWrap.removeAllChildren(); // 删除原来的龙
        _this.myDragon = _this._createDragon(dragonId);
        _this.myDragonId = dragonId;
        _this.aniObj.mainDragonWrap.addChild(_this.myDragon); // 添加到地台上
    }

    // 随机生成龙
    changeDragon(cb) {
        let _this = this;
        if (_this.randomDragonArr.length == 0) {
            // 没有初始过随机排序，先初始生成一个排序出来
            _this.randomDragonArr = _this._createRandomDragonArray(); // 先获取随机好的排序
        }
        // 一轮结束，从头开始
        if (_this.randomDragonIndex >= _this.randomDragonArr.length) {
            _this.randomDragonIndex = 0;
        }
        // 移动切换
        _this._moveMyDragon(() => {
            // 退场完成，更新龙，重新出场
            _this._createMyDragon(
                _this.randomDragonArr[_this.randomDragonIndex]
            );
            _this.randomDragonIndex++;
            cb && cb();
        });
    }

    // 我的龙移动
    _moveMyDragon(cb) {
        let _this = this;
        let _duration = 300;
        let _x_start = 350 + 123 + 175; // 初始位置
        let _x_center = 175; // 舞台中间
        let _x_end = -123 - 175; // 退场位置
        if (!_this.canChangeDragon) return;
        _this.canChangeDragon = false;
        createjs.Tween.get(_this.aniObj.mainDragonWrap)
            .to(
                {
                    x: _x_end
                },
                _duration
            )
            .call(() => {
                // 退场完了，可以重新出场了
                cb && cb();
                createjs.Tween.get(_this.aniObj.mainDragonWrap)
                    .to(
                        {
                            x: _x_start
                        },
                        0
                    )
                    .to(
                        {
                            x: _x_center
                        },
                        _duration
                    )
                    .call(() => {
                        // 出场完成
                        _this.canChangeDragon = true;
                    });
            });
    }

    // 生成随机龙排序
    _createRandomDragonArray() {
        let _this = this;
        let _idArr = [];
        for (const key in _this.dragonNameObj) {
            if (_this.dragonNameObj.hasOwnProperty(key)) {
                _idArr.push(key);
            }
        }
        return _this._getRandomArrayValue(_idArr, _idArr.length); // 随机生成排序
    }

    /**
     * 回到首页
     */
    goHome(showName = true) {
        let _this = this;
        if (!_this.canPk) {
            _this.canPk = true;
            // 停掉定时器
            clearInterval(_this.pkTimer);
        }
        // PK中，中断PK，清空重置pk双方
        _this._resetPkAni();
        _this._reversePlayer = false;
        // 清掉PK文案
        _this.pkWordsData = null;
        // 主页龙出场
        _this._myDragonStatus(true, 500, () => {
            // console.log('回到个人页');
        });
        // 昵称
        showName && _this.myName != '' && _this._nameBoxShowStatus(true, 500);
    }

    // 根据尺寸决定龙和地台的位置信息
    _state2pos() {
        // myDragonState
        //0:首次登录选龙（大）  1：已有龙（小）  2：登录后无PK记录+战力页状态（大+偏下）
        let y1_0 = 230; // 龙的初始位置
        let y1_1 = 230 + 125; // 龙的消失位置
        let y2_0 = 342.5; // 地台的初始位置
        let y2_1 = 342.5 + 125; // 地台的消失位置

        let deff = 0; // 偏移量
        if (this.myDragonState == 0) {
            // 0:首次登录选龙（大）
            deff = 0;
        }
        if (this.myDragonState == 1) {
            // 1：已有龙（小）
            deff = 50;
        }
        if (this.myDragonState == 2) {
            // 2：登录后无PK记录+战力页状态（大+偏下）
            deff = 160;
        }
        return {
            y1_0: y1_0 + deff, // 偏移后 龙的初始位置
            y1_1: y1_1 + deff, // 偏移后 龙的消失位置
            y2_0: y2_0 + deff, // 偏移后 地台的初始位置
            y2_1: y2_1 + deff // 偏移后 地台的消失位置
        };
    }

    /**
     * 我的龙显示状态
     * @param {Boolean} show 是否显示龙
     * @param {Number} duration 动画时长
     * @param {Function} cb 动画结束回调
     */
    _myDragonStatus(show = true, duration = 500, cb) {
        let _this = this;
        // 龙
        let dragon_y_0 = _this._state2pos().y1_0; // 龙的初始位置
        let dragon_y_1 = _this._state2pos().y1_1; // 龙的消失位置
        let ground_y_0 = _this._state2pos().y2_0; // 地台的初始位置
        let ground_y_1 = _this._state2pos().y2_1; // 地台的消失位置
        createjs.Tween.get(_this.aniObj.mainDragonWrap)
            .to(
                {
                    alpha: show ? 0 : 1,
                    y: show ? dragon_y_1 : dragon_y_0
                },
                0
            )
            .to(
                {
                    alpha: show ? 1 : 0,
                    y: show ? dragon_y_0 : dragon_y_1
                },
                duration,
                createjs.Ease.quadInOut
            )
            .call(function() {
                // 回调
                cb && cb();
            });
        // 地台
        createjs.Tween.get(_this.aniObj.mainGround)
            .to(
                {
                    alpha: show ? 0 : 1,
                    y: show ? ground_y_1 : ground_y_0
                },
                0
            )
            .to(
                {
                    alpha: show ? 1 : 0,
                    y: show ? ground_y_0 : ground_y_1
                },
                duration,
                createjs.Ease.quadInOut
            );
    }

    /**
     * pk双方显示状态
     * @param {Boolean} show pk双方出场还是退场
     * @param {Number} duration 动画时长
     * @param {Function} cb 结束回调
     */
    _playerStatus(show = false, duration = 300, cb) {
        let _this = this;
        let _p1_x_0 = -302.3; // p1初始位置
        let _p1_x_1 = -12; // p1出场后位置
        let _p2_x_0 = 175; // p2初始位置
        let _p2_x_1 = -110; // p2出场后位置

        // 重置Y轴位置
        _this._playerYStatus(false, 0);
        // 左侧
        createjs.Tween.get(_this.aniObj.player1)
            .to(
                {
                    alpha: show ? 0 : 1,
                    x: show ? _p1_x_0 : _p1_x_1
                },
                0
            )
            .to(
                {
                    alpha: show ? 1 : 0,
                    x: show ? _p1_x_1 : _p1_x_0
                },
                duration,
                createjs.Ease.backOut
            )
            .call(function() {
                // 回调
                cb && cb();
            });
        // 右侧
        createjs.Tween.get(_this.aniObj.player2)
            .to(
                {
                    alpha: show ? 0 : 1,
                    x: show ? _p2_x_0 : _p2_x_1
                },
                0
            )
            .to(
                {
                    alpha: show ? 1 : 0,
                    x: show ? _p2_x_1 : _p2_x_0
                },
                duration,
                createjs.Ease.backOut
            );
    }
    /**
     * pk垂直位置状态
     * @param {Boolean} show pk双方出场还是退场
     * @param {Number} duration 动画时长
     * @param {Function} cb 结束回调
     */
    _playerYStatus(show = false, duration = 300, cb) {
        let _this = this;
        let _p1_y_0 = 270; // p1初始位置
        let _p1_y_1 = 370; // p1出场后位置
        let _p2_y_0 = 270; // p2初始位置
        let _p2_y_1 = 370; // p2出场后位置
        // 左侧
        createjs.Tween.get(_this.aniObj.player1)
            .to(
                {
                    y: show ? _p1_y_0 : _p1_y_1
                },
                0
            )
            .to(
                {
                    y: show ? _p1_y_1 : _p1_y_0
                },
                duration,
                createjs.Ease.backOut
            )
            .call(function() {
                // 回调
                cb && cb();
            });
        // 右侧
        createjs.Tween.get(_this.aniObj.player2)
            .to(
                {
                    y: show ? _p2_y_0 : _p2_y_1
                },
                0
            )
            .to(
                {
                    y: show ? _p2_y_1 : _p2_y_0
                },
                duration,
                createjs.Ease.backOut
            );
    }

    /**
     * pk双方名牌显示状态
     * @param {Boolean} show 是否显示pk双方名牌
     * @param {Number} duration 动画时长
     * @param {Function} cb 结束回调
     */
    _playerNameStatus(show = false, duration = 500, cb) {
        let _this = this;

        let _p1_x_0 = -154.5; // p1名牌初始位置
        let _p1_x_1 = 160; // p1名牌出场后位置
        let _p2_x_0 = 742; // p2名牌初始位置
        let _p2_x_1 = 448; // p2名牌出场后位置

        // iconPk
        createjs.Tween.get(_this.aniObj.iconPk)
            .to(
                {
                    alpha: show ? 0 : 1
                },
                0
            )
            .to(
                {
                    alpha: show ? 1 : 0
                },
                show ? 300 : 0,
                createjs.Ease.quadInOut
            )
            .call(function() {
                // 回调
                cb && cb();
            });
        // p1名牌
        createjs.Tween.get(_this.aniObj.p1NameBox)
            .to(
                {
                    x: show ? _p1_x_0 : _p1_x_1
                },
                0
            )
            .to(
                {
                    x: show ? _p1_x_1 : _p1_x_0
                },
                duration,
                createjs.Ease.backOut
            );
        // p2名牌
        createjs.Tween.get(_this.aniObj.p2NameBox)
            .to(
                {
                    x: show ? _p2_x_0 : _p2_x_1
                },
                0
            )
            .to(
                {
                    x: show ? _p2_x_1 : _p2_x_0
                },
                duration,
                createjs.Ease.backOut
            );
    }

    /**
     * 昵称栏显示状态
     * @param {Boolean} show 是否显示昵称
     * @param {Number} duration 动画时长
     * @param {Function} cb 结束回调
     */
    _nameBoxShowStatus(show = false, duration = 500, cb) {
        let _this = this;
        let _start_y = -130;
        let _end_y = -40;
        // 昵称栏
        createjs.Tween.get(_this.aniObj.nameBox)
            .to(
                {
                    y: show ? _start_y : _end_y
                },
                0
            )
            .to(
                {
                    y: show ? _end_y : _start_y
                },
                duration,
                createjs.Ease.quadInOut
            )
            .call(() => {
                cb && cb();
            });
    }

    // 更新昵称栏内容
    updateNameBox(text) {
        let _this = this;
        _this.aniObj.nameBox.nameTextBox.text = text
            ? text
            : _this.translateNameText(
                  _this.myName,
                  _this.getDragonNameById(_this.myDragonId)
              );
    }

    // 翻译 xx 的龙 xx
    translateNameText(name, dragonName) {
        let _text = {
            zh: name + '的龙 ' + dragonName,
            en: name + "'s Dragon " + dragonName,
            ru: dragonName + ' Дракон игрока ' + name
        };
        return _text[this._lang] ? _text[this._lang] : _text['en'];
    }

    /**
     * 重播
     * @param {Object} enemy 敌方
     * @param {Object} pkwords pk过程文案
     * @param {Function} cb pk过程回调
     * @param {Function} endCb pk结束
     * @param {Boolean} immediately 是否立刻结束
     */
    replay(enemy, pkwords, cb, endCb, immediately = false) {
        let _this = this;
        _this.pkWordsData = pkwords;
        _this.pkFun(enemy, pkwords, cb, endCb, immediately);
    }

    /**
     * 快速战斗 - 立刻结束
     * @param {Object} enemy 敌方
     * @param {Object} pkwords pk过程文案
     * @param {Function} cb pk过程回调
     * @param {Function} endCb pk结束
     * @param {Boolean} immediately 是否立刻结束
     */
    fastPk(enemy, pkwords, cb, endCb, immediately = true) {
        let _this = this;
        _this.pkWordsData = pkwords;
        _this.pkFun(enemy, pkwords, cb, endCb, immediately);
    }

    /**
     * 发起pk
     * @param {Object} enemy 敌方
     * @param {Object} pkwords pk过程文案
     * @param {Function} cb pk过程回调
     * @param {Function} endCb pk结束
     * @param {Boolean} immediately 是否立刻结束
     */
    pk(enemy, pkwords, cb, endCb, immediately = false) {
        let _this = this;
        _this.pkWordsData = pkwords;
        _this._pkCount++; // 正常pk则次数+1
        _this.pkFun(enemy, pkwords, cb, endCb, immediately);
    }

    /**
     * pk动画方法
     * @param {Object} enemy 敌方
     * @param {Object} pkwords pk过程文案
     * @param {Function} cb pk过程回调
     * @param {Function} endCb pk结束
     * @param {Boolean} immediately 是否立刻结束
     */
    pkFun(enemy, pkwords, cb, endCb, immediately = false) {
        let _this = this;
        if (enemy.id == undefined) {
            // 没有pk玩家信息，跟NPC对战
            // enemy = this.npc;
            enemy = Object.assign(this.npc, enemy);
        }
        console.log(enemy);
        if (!_this.canPk) return; // pk中，需结束后才可进行下一场PK
        _this.canPk = false;
        _this.curView = 'PK'; // 开始PK后切换界面
        _this.curWinner = {}; // 重置胜者
        _this.changeDmLang(); // 隐藏弹幕
        // let _pkWords = _this.pkWordsData
        //     ? _this.pkWordsData
        //     : _this.createPkWords(); // 开始PK即生成对战文案
        let _pkWords = pkwords;
        console.log(_pkWords);

        // 昵称退场
        _this._nameBoxShowStatus(false, 300);

        // 清空上一场战斗的定时器
        clearInterval(_this.pkTimer);

        // 生成pk双方
        let _p1 = {
            id: _this.myDragonId,
            name: _this.myName
        };
        let _p2 = {
            id: enemy.id,
            name: enemy.name
        };
        // 创建双方龙并添加到舞台，传递比赛结果
        let isP1Win = enemy.winner ? false : true;
        _this.curWinner = isP1Win ? _p1 : _p2; // 记录当前胜者
        _this._readyToPk(_p1, _p2, isP1Win);

        // 宠物+地台退场
        _this._myDragonStatus(false, 500, playerGoIn);

        // pk双方入场
        function playerGoIn() {
            // pk双方入场
            _this._playerStatus(true, 300, function() {
                // 双方入场完毕
                startPk();
                _this.changePkEffect();
                // 开始战斗
                console.log(_this._lang);
                cb &&
                    cb(`<b>——${_this._basePkWords[_this._lang].pkstart}——</b>`);
            });
            // pk双方名牌出场
            _this._playerNameStatus(true, 300);
        }

        // 双方入场完毕
        let _curStep = 0;
        let aSteps = [0, 1, 5, 6, 7, 11];
        let bSteps = [2, 3, 4, 8, 9, 10];
        let _pkSteps = this._reversePlayer ? bSteps : aSteps;
        console.log('是否颠倒', this._reversePlayer);
        function startPk() {
            // 启动定时器，每次更新文案执行一次
            _this.pkTimer = setTimeout(
                () => {
                    if (_curStep >= _this.pkRound * _this.pkStep) {
                        // 当前已完成4个战斗周期
                        // 战斗结束
                        cb &&
                            cb(
                                `<b>——${
                                    _this._basePkWords[_this._lang].pkend
                                }——</b>`
                            );
                        endCb && endCb();
                        _curStep = 0;
                        _this.canPk = true;
                        _this._pkTextFlash(); // pk结果文字闪烁
                        _this.aniObj.pkEffect.removeAllChildren(); // 清掉当前对战动效
                        _this.pkWordsData = null;
                        _this._reversePlayer = false;
                        // console.log('pk场数', _this._pkCount);
                        clearTimeout(_this.pkTimer);
                        return;
                    }
                    if (_curStep % _this.pkStep == 0) {
                        // console.log('切换pk动效');
                        // 切换pk动效
                        !immediately && _this.changePkEffect();
                        // 双方互撞
                        !immediately &&
                            _this.hitAni(_pkSteps.includes(_curStep));
                    }
                    // 战斗文案
                    let _name = _pkSteps.includes(_curStep)
                        ? `<span style="color: #ff4848;">${_this.getDragonNameById(
                              _p1.id
                          )}</span>`
                        : `<span style="color: #4caf50;">${_this.getDragonNameById(
                              _p2.id
                          )}</span>`;
                    let _text = _pkWords.words[_curStep]
                        .replace('{玩家A}', _name)
                        .replace('{玩家B}', _name);
                    let _msg = `<i></i>${_text}`;
                    cb && cb(_msg);
                    _curStep++;
                    startPk();
                },
                immediately
                    ? 0
                    : _curStep == 0
                    ? 0
                    : _this.roundTime / _this.pkStep
            );
        }
    }

    // 龙碰撞动效，isPlayer1Attack = 是否玩家1攻击
    hitAni(isPlayer1Attack) {
        let _this = this;

        let _p1_x_0 = -12;
        let _p2_x_0 = -110;

        let _isPlayer1Attack = isPlayer1Attack; // 后面注释

        createjs.Tween.get(
            _isPlayer1Attack ? _this.aniObj.player1 : _this.aniObj.player2
        )
            .to(
                {
                    x: _isPlayer1Attack ? 72 : -190
                },
                300,
                createjs.Ease.backIn
            )
            .call(() => {
                createjs.Tween.get(
                    _isPlayer1Attack
                        ? _this.aniObj.player2
                        : _this.aniObj.player1
                )
                    // .wait(300)
                    .to(
                        {
                            x: _isPlayer1Attack ? -90 : -32
                        },
                        50
                        // createjs.Ease.sineIn
                    )
                    .to(
                        {
                            x: _isPlayer1Attack ? -140 : 12
                        },
                        100
                        // createjs.Ease.sineIn
                    )
                    .to(
                        {
                            x: _isPlayer1Attack ? -110 : -12
                        },
                        50
                        // createjs.Ease.sineIn
                    );
            })
            .to(
                {
                    x: _isPlayer1Attack ? -12 : -110
                },
                300
            );
    }

    // 切换pk动效
    changePkEffect() {
        let _this = this;
        _this.aniObj.pkEffect.removeAllChildren(); // 清掉当前对战动效
        let _effects = [
            'sword2',
            'boomAni',
            'boom2Ani',
            'fireAni',
            'fire2Ani'
            // 'arrowAni',// 要判断进攻还是防守切换方向
        ];
        let _newEffects = _effects[_this._randomNum(0, _effects.length - 1)];
        while (_this.pkEffect == _newEffects) {
            _newEffects = _effects[_this._randomNum(0, _effects.length - 1)];
        }
        _this.pkEffect = _newEffects;
        _this.aniObj.pkEffect.addChild(new lib[_newEffects]()); // 添加新的对战动效
        // 缓动入场
        createjs.Tween.get(_this.aniObj.pkEffect)
            .to(
                {
                    alpha: 0
                },
                0
            )
            .to(
                {
                    alpha: 1
                },
                300
            );
    }

    // 重置动画位置
    _resetPkAni() {
        let _this = this;

        _this.aniObj.tWinner.alpha = 0;
        _this.aniObj.tLoser.alpha = 0;
        _this.aniObj.player1.bbb1.removeAllChildren();
        _this.aniObj.player2.aaa1.removeAllChildren();
        // player 双方位置准备
        _this._playerStatus(false, 0);
        _this._playerNameStatus(false, 0);
        // 清掉当前对战动效
        _this.aniObj.pkEffect.removeAllChildren();
        // 清掉pk文案和颠倒状态
        _this.pkWordsData = null;
    }

    // 生成pk双方
    _readyToPk(p1, p2, isP1Win) {
        let _this = this;
        let _player1Dragon = _this._createDragon(p1.id);
        let _player2Dragon = _this._createDragon(p2.id);

        // 重置pk双方
        _this._resetPkAni();

        // 设置主人和龙昵称
        _this.aniObj.p1NameBox.text_p1_name.text = p1.name + "'s";
        _this.aniObj.p1NameBox.text_p1_dragon_name.text = _this.getDragonNameById(
            p1.id
        );
        _this.aniObj.p2NameBox.text_p2_name.text = p2.name + "'s";
        _this.aniObj.p2NameBox.text_p2_dragon_name.text = _this.getDragonNameById(
            p2.id
        );

        // 左侧龙（我的）
        _player1Dragon.regX = 175;
        _player1Dragon.regY = 175;
        _player1Dragon.x = 175;
        _player1Dragon.y = 175;
        _player1Dragon.skewY = 180; // 翻转
        _player1Dragon.scaleX = 0.9;
        _player1Dragon.scaleY = 0.9;
        _this.aniObj.player1.bbb1.addChild(_player1Dragon);
        _this.aniObj.player1.bbb1.addChild(
            isP1Win ? _this.aniObj.tWinner : _this.aniObj.tLoser
        );

        // 右侧龙（敌方）
        _player2Dragon.regX = 175;
        _player2Dragon.regY = 175;
        _player2Dragon.x = 175;
        _player2Dragon.y = 175;
        _player2Dragon.scaleX = 0.9;
        _player2Dragon.scaleY = 0.9;
        _this.aniObj.player2.aaa1.addChild(_player2Dragon);
        _this.aniObj.player2.aaa1.addChild(
            isP1Win ? _this.aniObj.tLoser : _this.aniObj.tWinner
        );
    }

    // pk结果动效
    _pkTextFlash() {
        let _this = this;
        let _flashTimes = 5; //字闪烁次数
        function tFlash(obj) {
            let _times = 0;

            function _flash() {
                _times++;
                if (!_this.canPk) {
                    // 避免胜负闪烁动画延续到下一场PK
                    createjs.Tween.get(obj).to(
                        {
                            alpha: 0
                        },
                        0
                    );
                    return;
                }
                if (_times >= _flashTimes) return;
                createjs.Tween.get(obj)
                    .wait(100)
                    .to(
                        {
                            alpha: 0
                        },
                        50
                    )
                    .wait(100)
                    .to(
                        {
                            alpha: 1
                        },
                        50
                    )
                    .call(_flash);
            }
            _flash();
        }

        tFlash(_this.aniObj.tWinner);
        tFlash(_this.aniObj.tLoser);
    }

    // 根据id获取龙的名字
    getDragonNameById(dragonId) {
        return this.dragonNameObj[dragonId].name;
    }

    // 根据id（ename）获取龙信息
    getDragonDataById(dragonId) {
        return this.dragonNameObj[dragonId];
    }

    // 根据唯一id获取龙信息
    getDragonDataByTrueId(id) {
        let _data = {};
        let _dragonNameObj = this.dragonNameObj;
        for (let key in _dragonNameObj) {
            if (_dragonNameObj[key].id == id) {
                _data = _dragonNameObj[key];
            }
        }
        return _data;
    }

    // 特殊处理重播pk数据（攻击方和被攻击方互换）
    handlePkData(pkdata, user_id) {
        // 我的用户id
        let _myUserid = user_id;
        // pkdata
        let _player1_id = pkdata.user_id; // 主动发起攻击的玩家
        let _player2_id = pkdata.object_id; // 被攻击的玩家

        console.log(987, _myUserid, _player1_id, _player2_id);
        let _player2_data = {}; // 对面玩家
        if (_myUserid == _player1_id) {
            // 数据不需要反转。正常播放即可
            _player2_data = {
                player1: {}, // 暂不需要
                player2: {
                    id: pkdata.dragon_ename_object,
                    name: pkdata.object_name,
                    winner: pkdata.status == 2 // 是否胜利（玩家自己的胜利状态：1胜利 2失败，statys=2时，对手胜利）
                }
            };
        } else if (_myUserid == _player2_id) {
            // 我是被攻击的一方，需要反转数据
            this._reversePlayer = true;
            _player2_data = {
                player1: {}, // 暂不需要
                // 返回player2玩家数据
                player2: {
                    id: pkdata.dragon_ename,
                    name: pkdata.user_name,
                    winner: pkdata.status == 1
                }
            };
        }

        return _player2_data;
    }

    // 游戏画面导base64
    toBase64(quality = 0.7) {
        return new Promise((resolve, reject) => {
            let _dom = document.querySelector('#animation_container #canvas');
            let _bs64 = _dom.toDataURL('image/jpeg', quality);
            resolve(_bs64);
        });
    }

    // 获取我的龙的名字
    get myDragonName() {
        return this.getDragonNameById(this.myDragonId);
    }

    // 是否可以PK
    get canPk() {
        return this._canPk;
    }

    set canPk(val) {
        this._canPk = val;
    }

    set lang(val) {
        val = val != 'en' || val != 'ru' ? 'en' : val;
        if (val) {
            this.changeDmLang(val);
            this.changeFontFamily(val);
            this._lang = val;
        }
    }

    set pkCount(val) {
        this._pkCount = val;
    }

    get pkCount() {
        return this._pkCount;
    }

    set reversePlayer(val) {
        this._reversePlayer = val;
    }

    get reversePlayer() {
        return this._reversePlayer;
    }

    // 取两数之间的随机数
    _randomNum(min, max) {
        return Math.floor(Math.random() * (max - min + 1)) + min;
    }

    // 从数组中获取指定数量的元素，且不重复
    _getRandomArrayValue(arr, num) {
        if (num > arr.length) return arr;
        var sData = arr.slice(0),
            i = arr.length,
            min = i - num,
            item,
            index;
        while (i-- > min) {
            index = Math.floor((i + 1) * Math.random());
            item = sData[index];
            sData[index] = sData[i];
            sData[i] = item;
        }
        return sData.slice(min);
    }

    // 生成对战文案，需随机生成一次PK文案（4轮）
    createPkWords() {
        let _this = this;
        let _pkWordsArr = [];
        let _id = [];
        let _randomWords = _this._getRandomArrayValue(
            _this.pkTextList,
            _this.pkRound
        );
        for (let i = 0; i < _randomWords.length; i++) {
            _id.push(_randomWords[i].id);
            for (let j = 0; j < _randomWords[i].content.length; j++) {
                _pkWordsArr.push(_randomWords[i].content[j]);
            }
        }

        let _pkWordsData = {
            ids: _id.join(','),
            words: _pkWordsArr
        };
        _this.pkWordsData = _pkWordsData;
        return _pkWordsData;
    }

    // 接口返回的对战记录转可用的对战文案
    content2pkWords(arr) {
        let _pkWordsArr = [];
        for (let i = 0; i < arr.length; i++) {
            for (let j = 0; j < arr[i].length; j++) {
                _pkWordsArr.push(arr[i][j]);
            }
        }
        return _pkWordsArr;
    }

    // 更新登录状态（我的龙大小位置）
    setMyDragonState(state) {
        this.myDragonState = state;
        // 我的龙
        this.aniObj.mainDragonWrap.scaleX = state == 1 ? 0.84 : 1;
        this.aniObj.mainDragonWrap.scaleY = state == 1 ? 0.84 : 1;
    }

    changeFontFamily(lang) {
        let _fontFamily = lang == 'ru' ? 'silver' : 'Dotted Songti Square'; // 字体
        this.aniObj.nameBox.nameTextBox.font = '30px ' + _fontFamily;
        this.aniObj.p1NameBox.text_p1_dragon_name.font = '30px ' + _fontFamily;
        this.aniObj.p1NameBox.text_p1_name.font = '30px ' + _fontFamily;
        this.aniObj.p2NameBox.text_p2_dragon_name.font = '30px ' + _fontFamily;
        this.aniObj.p2NameBox.text_p2_name.font = '30px ' + _fontFamily;
    }

    // 初始化部分元件位置
    resetAniObjPosition() {
        // // 先清掉弹幕，测试阶段有点卡顿
        // setTimeout(() => {
        //     this.aniObj.dmWrap.removeAllChildren();
        // }, 10);
        //设置字体
        // this.changeFontFamily();
        // 昵称栏
        this.aniObj.nameBox.y = -130;

        // winner和loser位置初始化
        this.aniObj.tWinner.regX = 218 / 2;
        this.aniObj.tWinner.regY = 62 / 2;
        this.aniObj.tWinner.x = 350 / 2;
        this.aniObj.tWinner.y = -20;
        this.aniObj.tWinner.alpha = 0;
        this.aniObj.tLoser.regX = 218 / 2;
        this.aniObj.tLoser.regY = 62 / 2;
        this.aniObj.tLoser.x = 350 / 2;
        this.aniObj.tLoser.y = -20;
        this.aniObj.tLoser.alpha = 0;

        // pk双方昵称字体颜色
        this.aniObj.p1NameBox.text_p1_name.color = '#671915';
        this.aniObj.p2NameBox.text_p2_name.color = '#04514b';

        // pk动效
        this.aniObj.pkEffect.scaleX = 0.6;
        this.aniObj.pkEffect.scaleY = 0.6;
        this.aniObj.pkEffect.y = 150;

        // 我的龙
        this.aniObj.mainDragonWrap.scaleX = this.isLogin ? 0.84 : 1;
        this.aniObj.mainDragonWrap.scaleY = this.isLogin ? 0.84 : 1;

        // 弹窗
        // this.aniObj.popWinner.alpha = 0;
        // this.aniObj.popDownload.alpha = 0;
        this.aniObj.popDownload.downloadPopDragonWrap.scaleX = 0.8;
        this.aniObj.popDownload.downloadPopDragonWrap.scaleY = 0.8;
        this.aniObj.popDownload.downloadPopDragonWrap.y = 406.6 + 40;
    }
}

export default gameAni;
